// 报警记录
import httpRequest from '@/utils/request.js';

// 获取报警记录分页
export const getAlarmRecordPage = params =>
    httpRequest.httpGet({
        url: '/service/alarmRecord/lst',
        params
    });

// 获取报警记录详情
export const getAlarmRecordDetail = params => {
    return httpRequest.httpGet({
        url: '/service/alarmRecord/detail',
        params
    });
};

// 异常内容详细
export const getExContentDetail = sendId => {
    return httpRequest.httpGet({
        url: `/service/alarmRecord/ex`,
        params: {
            sendId
        }
    });
};

// 删除报警记录

export const delAlarmRecord = params => {
    return httpRequest.httpdelete2('/service/alarmRecord/delete', params);
};
